module.exports = __webpack_public_path__ + "img/Jimny.12fde780.png";